import { useEffect, useState } from 'react';

/** 是否在凤凰客户端内 */
export const isGrounds = typeof window !== 'undefined' && !!window.grounds;

/** 鸿蒙手机锁定客户端为浅色模式 */
const lockHarmonyLightMode = () => {
    const mark = navigator.userAgent.toLocaleLowerCase();

    if (window?.grounds?.setDarkMode && mark.includes('arkweb')) {

        window.grounds.setDarkMode('light');
    }
};

/** 关闭当前客户端 webview */
export const groundsClose = () => {
    if (isGrounds && window.grounds.close) {
        window.grounds.close();
    }
};

const withAppQuery = url => {
    try {
        const urlObj = new URL(url);

        if (!urlObj.searchParams.has('isFull')) urlObj.searchParams.set('isFull', '0');
        if (!urlObj.searchParams.has('immersion')) urlObj.searchParams.set('immersion', 'true');
        if (!urlObj.searchParams.has('ifengsp')) urlObj.searchParams.set('ifengsp', '1');

        return urlObj.href;
    } catch (e) {
        return url;
    }
};

/** 打开客户端分享托盘；端外走系统分享 */
export const openAppShare = ({ url = `${window.location.origin}${window.location.pathname}`, title = '', desc = '', thumbnail = '', documentId = 'ucms_8xZ5jTmnVJB' } = {}) => {
    const shareUrl = withAppQuery(url);

    if (isGrounds && window.grounds.openShare) {
        window.grounds.openShare(shareUrl, title, desc, thumbnail, documentId);

        return;
    }

    if (navigator.share) {
        navigator.share({ title, text: desc, url: shareUrl }).catch(() => undefined);
    }
};

/**
 * 端内全屏，并返回状态栏高度。
 * 安卓返回的是物理像素，需要除以 devicePixelRatio。
 * @returns {number}
 */
export const useMaximize = () => {
    const [statusBarHeight, setStatusBarHeight] = useState(0);

    useEffect(() => {
        if (!window.grounds) {
            return;
        }

        lockHarmonyLightMode();

        if (window.grounds.maximization && window.grounds.getStatusBarHeight && window.grounds.getDeviceInfo) {
            const os = window.grounds.getDeviceInfo().getOs() || '';
            const isAndroid = /android/i.test(os);
            const ratio = isAndroid ? window.devicePixelRatio || 1 : 1;
            const height = window.grounds.getStatusBarHeight() / ratio;

            window.grounds.maximization();
            setStatusBarHeight(height);
        }

        if (window.grounds.disableBounceEffect) {
            window.grounds.disableBounceEffect('close');
        }
    }, []);

    return statusBarHeight;
};

/**
 * 端内日夜间模式。
 * @returns {boolean}
 */
export const useNightMode = () => {
    const [isNightMode, setIsNightMode] = useState(false);

    useEffect(() => {
        if (!window.grounds) {
            return;
        }

        const nightMode = 'night';

        if (window.grounds.getShowMode) {
            setIsNightMode(window.grounds.getShowMode() === nightMode);
        }

        if (window.grounds.on) {
            const showModeCallback = 'usmidterm2026ShowModeCallback';

            window[showModeCallback] = current => {
                setIsNightMode(current === nightMode);
            };

            window.grounds.on('theme', showModeCallback);
        }
    }, []);

    return isNightMode;
};
